const ADJECTIVES = [
  "Amber",
  "Bright",
  "Calm",
  "Celadon",
  "Clear",
  "Golden",
  "Silver",
  "Swift",
];

const NOUNS = [
  "Beam",
  "Cloud",
  "Harbor",
  "Meadow",
  "Orbit",
  "River",
  "Stone",
  "Wave",
];

function isObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

function unwrapPayload(payload) {
  if (!isObject(payload)) return payload;
  if (payload.data != null) return payload.data;
  return payload;
}

function resolveSessionIsSandbox(payload, root) {
  const values = [payload, root].filter(isObject);
  return values.some(
    (value) =>
      value.is_sandbox === true ||
      value.in_sandbox === true ||
      value.current_mode === "sandbox" ||
      value.mode === "sandbox",
  );
}

function looksLikeSandbox(value) {
  return (
    isObject(value) &&
    (value.id != null ||
      value.sandbox_id != null ||
      value.company_id != null ||
      typeof value.name === "string")
  );
}

function normalizeSandboxItem(item, index) {
  const id = item.id ?? item.sandbox_id ?? item.company_id ?? `sandbox-${index}`;
  return {
    ...item,
    id,
    name: String(item.name || item.company_name || `Sandbox ${index + 1}`),
  };
}

export function normalizeSandboxInfo(payload) {
  const root = unwrapPayload(payload);
  let rawItems = [];

  if (Array.isArray(root)) {
    rawItems = root;
  } else if (isObject(root) && Array.isArray(root.sandboxes)) {
    rawItems = root.sandboxes;
  } else if (isObject(root) && looksLikeSandbox(root.sandbox)) {
    rawItems = [root.sandbox];
  } else if (looksLikeSandbox(root) && root.exists !== false) {
    rawItems = [root];
  }

  return {
    sandboxes: rawItems.filter(looksLikeSandbox).map(normalizeSandboxItem),
    isSandboxSession: resolveSessionIsSandbox(payload, root),
    originalCompanyName:
      root?.original_company_name ||
      root?.live_company_name ||
      payload?.original_company_name ||
      null,
  };
}

export function generateSandboxName(random = Math.random) {
  const adjective = ADJECTIVES[Math.floor(random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(random() * NOUNS.length)];
  return `${adjective} ${noun}`;
}

export function validateSandboxName(value, messages = {}) {
  const name = String(value ?? "").trim();
  if (!name) return messages.required || "Enter a sandbox name.";
  if (name.length > 80) {
    return (
      messages.tooLong || "Sandbox name must be 80 characters or fewer."
    );
  }
  return "";
}
